import EmploymentAllowanceText from '@/components/requests/EmploymentAllowanceText'

export default class ExceedsRemainingEmploymentAllowanceText extends EmploymentAllowanceText {
  getText() {
    return `This request exceeds ${this._getOwnerText()} remaining allowance for the year.`
  }
}
